<script>
import ItemComponent from './Item/component.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    module: {
      type: Object,
    },
  },
  methods: {
    add() {
      this.module.add();
    },
    remove(item) {
      this.module.remove(item);
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      Тарифы
      <BtnPrimary
        slot="btn"
        @click="add"
      >
        Добавить тариф
      </BtnPrimary>
    </CardTitle>
    <ItemComponent
      v-for="(item, idx) in module.items"
      :key="idx"
      :module="item"
      @remove="remove(item)"
    />
    <CardNoLength v-if="!module.items.length">
      Добавьте тарифы
    </CardNoLength>
  </Card>
</template>
<style lang="scss">

</style>
